"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var reselect_1 = require("reselect");
var viewport_1 = __importDefault(require("../../viewport"));
var selectors_1 = require("../selectors");
var OddContainerComponent = /** @class */ (function (_super) {
    __extends(OddContainerComponent, _super);
    function OddContainerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OddContainerComponent.prototype.render = function () {
        var _a = this.props, odd = _a.odd, isActive = _a.isActive, isCompact = _a.isCompact, ViewOdd = _a.component, props = _a.props;
        return (react_1.default.createElement(ViewOdd, __assign({ odd: odd, isActive: isActive, isCompact: isCompact }, props)));
    };
    return OddContainerComponent;
}(react_1.default.Component));
var selectIsCompact = viewport_1.default.selectors.selectIsCompact;
var makeMapStateToProps = function () {
    return reselect_1.createSelector(selectors_1.selectOddWithAvailability, selectIsCompact, function (oddWithAvailability, isCompact) { return (__assign(__assign({}, oddWithAvailability), { isCompact: isCompact })); });
};
function makeOddContainerFor() {
    return react_redux_1.connect(makeMapStateToProps)(OddContainerComponent);
}
exports.default = makeOddContainerFor;
//# sourceMappingURL=OddContainer.js.map